import { render, staticRenderFns } from "./warehouse-dimension.vue?vue&type=template&id=b8ad431e&"
import script from "./warehouse-dimension.vue?vue&type=script&lang=js&"
export * from "./warehouse-dimension.vue?vue&type=script&lang=js&"
import style0 from "./warehouse-dimension.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports